import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (window?.console) {
    window.console.log = function () { };
    window.console.warn = function () { };
    window.console.info = function () { };
    window.console.error = function () { };
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
